import request from '@/utils/request'

// web 活动详情
export const webDetails = data => request({
    url: '/api/v1/repast/webDetails',
    method: 'post',
    data
})
